const Model = Mindbreeze['require']('backbone').Model;
const PropertiesModel = Mindbreeze['require']('model/properties');

export default class Base extends Model {
  get(key) {
    return new PropertiesModel(this.attributes).get(key, {
      format: 'VALUE',
    });
  }

  set(key, val, options, ...rest) {
    if (key == null) return this;

    var attrs;
    if (typeof key === 'object') {
      attrs = key;
      options = val;
    } else {
      (attrs = {})[key] = val;
    }

    super.set(key, val, options, ...rest);
  }

  submodel(path) {
    return this.get(path);
  }
}
